import '../Sys/config.js';

const SCRIPT_ID = 'google-maps-places';
let loader = null;

export const googleMapsApiKey = () => global.googleMapsApiKey || '';

/** Loads the Maps JavaScript API with the Places library once. Resolves to `google.maps` or null. */
export const loadGooglePlaces = () => {
    if (typeof window === 'undefined') return Promise.resolve(null);
    if (window.google?.maps?.places) return Promise.resolve(window.google.maps);
    const key = googleMapsApiKey();
    if (!key) return Promise.resolve(null);
    if (loader) return loader;
    loader = new Promise((resolve) => {
        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.async = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places&loading=async`;
        script.onload = () => resolve(window.google?.maps?.places ? window.google.maps : null);
        script.onerror = () => {
            loader = null;
            resolve(null);
        };
        document.head.appendChild(script);
    });
    return loader;
};

/** Reads city, province and postal code from a Places result for optional autofill. */
export const addressPartsFromPlace = (place) => {
    const parts = { city: '', province: '', pincode: '', country: '' };
    (place?.address_components || []).forEach((component) => {
        const types = component.types || [];
        if (types.includes('locality') || (!parts.city && types.includes('postal_town'))) parts.city = component.long_name;
        if (types.includes('administrative_area_level_1')) parts.province = component.long_name;
        if (types.includes('postal_code')) parts.pincode = component.long_name;
        if (types.includes('country')) parts.country = component.long_name;
    });
    return parts;
};
